// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3xODv","itemTitle":"ClientEmergencyInfo_itemTitle__3cThR","itemText":"ClientEmergencyInfo_itemText__2FHVb"};